import { isErrorWithStatus } from '.';

export const isAddOnInUseError = isErrorWithStatus( 400, 'invalid_workspace' );
export const isMembersAddOnInUseError = isErrorWithStatus( 400, 'invalid_members' );
